module.exports = __webpack_public_path__ + "img/bx-10.7ffe80ea.jpg";